export default {
      id: "voca-usage",
      viewBox: "0 0 100 18",
      url: "assets/" + "sprite.svg#voca-usage",
      toString: function () {
        return this.url;
      }
    }